<template>
  <b-card
    no-body
  >
    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>{{ $t('Entries') }}</label>
          <v-select
            v-model="perPage"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
          <b-button
            v-b-toggle.sidebar-create-ask
            variant="primary"
            class="mr-1"
          >
            {{ $t('Create') }}
          </b-button>

          <b-button
            variant="success"
            @click="$router.push({ name: 'quote-distribution-additional-dist' })"
          >
            {{ $t('Distribute') }}
          </b-button>
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('Search...')"
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="askQuoteTable"
      :items="list"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      :empty-text="$t('No matching records found')"
      :sort-desc.sync="isSortDirDesc"
      :busy="isBusy"
      class="position-relative"
    >
      <template #head()="data">
        {{ $t(data.label) }}
      </template>

      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template #cell(from_org)="data">
        {{ $langName(data.value.name) }}
      </template>

      <template #cell(period)="data">
        {{ data.value.admission_year + '-' + data.value.name }}
      </template>

      <template #cell(status)="data">
        <b-badge :variant="getQuoteDistributionStatusColor(data.value)">
          {{ $langName(getQuoteDistributionStatus(data.value).name) }}
        </b-badge>
      </template>
      <template #cell(file)="data">
        <router-link :to="{ name: 'pdf-viewer', params: { url: data.value }}">
          <feather-icon
            icon="EyeIcon"
            class="cursor-pointer"
            size="16"
          />
        </router-link>
      </template>
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            variant="primary"
            label=""
          />
        </div>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">
          <feather-icon
            icon="EyeIcon"
            class="cursor-pointer mr-1"
            size="16"
            @click="$router.push({ name: 'ask-view', params: { totalQuoteId: data.item.id }})"
          />
        </div>
      </template>

    </b-table>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">{{ $t("table summary", { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of }) }} </span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>
      </b-row>
      <create @refetchData="refetchData" />
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BSpinner,
  BTable, BPagination, VBToggle, BBadge,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import config from './config'
import Create from './Create.vue'
import store from '@/store'

export default {
  name: 'List',
  directives: {
    'b-toggle': VBToggle,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    vSelect,
    Create,
    BSpinner,
    BBadge,
  },
  computed: {
    letter() {
      return this.$store.state[this.MODULE_NAME].letter
    },
  },
  created() {
    this.extraParams = {
      total_quote_type: this.totalQuoteTypeRequest,
      period_id: this.letter.period.id,
      from_org: this.letter.from_org.id,
    }
  },
  methods: {
    getQuoteDistributionStatus(id) {
      return this.$store.getters['staticModule/getQuoteDistributionStatus'](id)
    },
    getQuoteDistributionStatusColor(id) {
      return this.$store.getters['staticModule/getQuoteDistributionStatusColor'](id)
    },
  },
  setup() {
    const MODULE_NAME = 'quoteDistributionOtm'
    const { totalQuoteTypeRequest } = store.state.staticModule
    return {
      ...config(MODULE_NAME),
      MODULE_NAME,
      totalQuoteTypeRequest,
    }
  },
}
</script>

<style scoped>

</style>
